import React, { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Container } from '../../locations/BulkEdit/EditInformations/styles'
import styled from 'styled-components'
import { LoadableCard } from '~/components/commons'
import { CustomInput } from 'reactstrap'
import { useSelector } from 'react-redux'
import useAxios from 'axios-hooks'

const EditNPSForm = () => {
  const accountId = useSelector(state => state.user?.profile?.account?.id)
  const [isModuleEnabled, setIsModuleEnabled] = React.useState(false)
  const [stars, setStars] = React.useState(5)
  const [isDirty, setIsDirty] = React.useState(false)
  const intl = useIntl()

  const [{ data, loading: loadingData }, refetch] = useAxios({
    url: `/nps/account/${accountId}`,
    method: 'GET',
  })

  const [{ loading: loadingMutate }, updateNPS] = useAxios(
    {
      url: `/nps/account/${accountId}`,
      method: 'PATCH',
    },
    {
      manual: true,
    }
  )

  const resetForm = () => {
    setIsModuleEnabled(data.active)
    if (data.active) {
      setStars(data.starsToGoogle)
    }
    setIsDirty(false)
  }

  useEffect(() => {
    if (!data) {
      return
    }
    resetForm()
  }, [data])
  const isLoading = loadingData || loadingMutate
  const handleSubmit = async e => {
    e.preventDefault()
    try {
      await updateNPS({
        data: {
          active: isModuleEnabled,
          starsToGoogle: stars,
        },
      })
      refetch()
    } catch (error) {
      console.error(error)
    } finally {
    }
  }

  return (
    <LoadableCard className="p-3" loading={isLoading}>
      <Container>
        <StyledForm>
          <div className="form_row">
            <h2>
              <FormattedMessage id="NPS" />
            </h2>
          </div>
          <div className="form_row">
            <label>
              <FormattedMessage id="Enable NPS module" />
            </label>
            <StyledSwitch
              id={`edit-switch`}
              checked={isModuleEnabled}
              style={{ zIndex: '0 !important' }}
              onChange={() => {
                setIsModuleEnabled(bool => !bool)
                setIsDirty(true)
              }}
              type="switch"
              disabled={isLoading}
              inline
            >
              <FormattedMessage id={isModuleEnabled ? 'Active' : 'Inactive'} />
            </StyledSwitch>
          </div>
          <div className="form_column">
            <label>
              <FormattedMessage id="Forward to Google" />
            </label>
            <CustomInput
              id="exampleSelect"
              name="select"
              type="select"
              disabled={!isModuleEnabled}
              value={stars}
              onChange={e => {
                setStars(e.target.value)
                setIsDirty(true)
              }}
            >
              <option value={1}>
                1 {intl.formatMessage({ id: 'Star' }).toLowerCase()}
              </option>
              <option value={2}>
                2 {intl.formatMessage({ id: 'Stars' }).toLowerCase()}
              </option>
              <option value={3}>
                3 {intl.formatMessage({ id: 'Stars' }).toLowerCase()}
              </option>
              <option value={4}>
                4 {intl.formatMessage({ id: 'Stars' }).toLowerCase()}
              </option>
              <option value={5}>
                5 {intl.formatMessage({ id: 'Stars' }).toLowerCase()}
              </option>
            </CustomInput>
          </div>

          <div className="buttons__wrapper">
            <button disabled={isLoading || !isDirty} onClick={resetForm}>
              <FormattedMessage id="Cancel" />
            </button>
            <button disabled={isLoading || !isDirty} onClick={handleSubmit}>
              <FormattedMessage id="Save Changes" />
            </button>
          </div>
        </StyledForm>
      </Container>
    </LoadableCard>
  )
}

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  h2 {
    color: #2c2c2c;
    font-family: Montserrat;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  label {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 500;
    flex: 1 0 0;
  }

  .form_row {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
  }

  .form_column {
    display: flex;
    gap: 1rem;
    flex-direction: column;
  }

  .buttons__wrapper {
    display: flex;
    align-items: center;
    gap: 15px;

    & button:first-child {
      padding: 0.5rem 1rem;
      background-color: transparent;
      border-radius: 0.4rem;
      border: 1px solid #979797;
      transition: all 0.3s;
      color: #979797;
      &:hover {
        color: #000;
        border-color: #000;
      }
      &:disabled {
        opacity: 0.65;
      }
    }

    & button:last-child {
      width: fit-content;
      padding: 0.5rem 1rem;
      background-color: #61c478;
      border-radius: 0.4rem;
      border: none;
      color: white;

      &:disabled {
        opacity: 0.65;
      }
    }
  }
`

export const StyledSwitch = styled(CustomInput)`
  display: flex;
  flex-direction: form_row-reverse;
  gap: 10px;
  span {
    margin-right: 10px;
    color: #a8a8a8;
    font-size: 14px;
  }
`

export default EditNPSForm
